import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const physicianService = {
    getImportance: (companyId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TARGETLIST}/${API_PATH.IMPORTANCE}`),
    getIntensity: (companyId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.INTENSITY}`),
    postImportance: (companyId, data) => axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PHYSICIANS}/${API_PATH.IMPORTANCE}`, data),
    postIntensity: (companyId, data) => axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.INTENSITY}`, data),
    getPhysiciansList: (companyId, position,page_size,searchValue='') => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PHYSICIANS + API_PATH.POSITIONQUERY + position}&${API_PATH.PAGE_SIZE_QUERY + page_size}${'&q='+searchValue}`),
    getHcpProfileData: (companyId, npiId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PHYSICIAN}/${npiId}/${API_PATH.HCPPROFILEDATA}`)
    
};

export default physicianService;
